import React from "react";

import { CustomIconsForBubble } from "../../platform-style";

interface ViewAndEditIconsForBubbleProps {
  title?: string;
  tag: string;
  isHistorical: boolean;
  allowModify: boolean;
  handleViewClick?: () => void;
  handleEditClick?: () => void;
  children?: React.JSX.Element;
}

interface Button {
  icon: "faListUI" | "faPenToSquare" | "faEye" | "faDownload";
  type: "view" | "edit" | "download";
  tooltip: string;
  action?: () => void;
}

/**
 * @deprecated Use ActionBubble instead.
 */
export const ViewAndEditIconsForBubble = ({
  title,
  tag,
  isHistorical,
  allowModify,
  handleViewClick,
  handleEditClick,
  children,
}: ViewAndEditIconsForBubbleProps) => {
  function getButtons(): Button[] {
    let buttons: Button[] = [
      {
        icon: "faListUI",
        type: "view",
        tooltip: "View Details",
        action: handleViewClick,
      },
    ];

    if (allowModify) {
      buttons.push({
        icon: "faPenToSquare",
        type: "edit",
        tooltip: "Edit Details",
        action: handleEditClick,
      });
    }

    if (isHistorical) buttons = [];

    return buttons;
  }

  return (
    <CustomIconsForBubble title={title} tag={tag} buttons={getButtons()}>
      {children}
    </CustomIconsForBubble>
  );
};
